import secondaryComponents from "../../../../components/secondaryComponents";
import primaryComponents from "../../../../components/primaryComponents";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import useJournalEntriesTab from "./useJournalEntriesTab";

const JournalEntriesTab = ({ journalStatus }) => {
  const {
    isLoadingJournalEntries,
    journalEntries,
    metaDetails,
    storeList,
    storeHasMultipleCurrency,
    startDate,
    endDate,
    currentStore,
    sourceModules,
    entryTypes,
    sourceModule,
    entryType,
    setDateFilter,
    setStoreFilter,
    handleFetchJournalEntries,
    gotoPage,
    setSourceModuleFilter,
    setEntryTypeFilter,
  } = useJournalEntriesTab({ journalStatus });
  return (
    <>
      <div className={`${globalStyles.tableHeader} justify-content-between`}>
        <div className="d-flex" style={{ gap: "10px" }}>
          <div style={{ width: "200px" }}>
            <primaryComponents.SelectField
              options={
                storeHasMultipleCurrency
                  ? [...storeList]
                  : [
                      {
                        name: "All stores",
                        id: "ALL_STORES",
                      },
                      ...storeList,
                    ]
              }
              label={"Filter Store"}
              idKey="id"
              nameKey="name"
              onChange={(value) => {
                setStoreFilter(value);
              }}
              value={
                storeList?.find(
                  (storeItem) => `${storeItem?.id}` === `${currentStore}`,
                )?.name || "All stores"
              }
              floatError={false}
              classNames="store-select"
            />
          </div>
          <div className="ml-auto" style={{ width: "200px" }}>
            <primaryComponents.SelectField
              options={sourceModules}
              idKey="id"
              nameKey="name"
              onChange={(value) => {
                setSourceModuleFilter(value);
              }}
              label={"Filter Source Module"}
              value={
                sourceModules?.find(
                  (sourceModuleItem) =>
                    `${sourceModuleItem?.id}` === `${sourceModule}`,
                )?.name || "All source modules"
              }
              floatError={false}
            />
          </div>
          <div className="ml-auto" style={{ width: "200px" }}>
            <primaryComponents.SelectField
              options={entryTypes}
              idKey="id"
              nameKey="name"
              onChange={(value) => {
                setEntryTypeFilter(value);
              }}
              label={"Entry Type"}
              value={
                entryTypes?.find(
                  (entryTypeItem) => `${entryTypeItem?.id}` === `${entryType}`,
                )?.name || "All entry types"
              }
              floatError={false}
            />
          </div>
        </div>
        <div>
          <label htmlFor="">Date Range</label>
          <primaryComponents.DateRangeInput
            startDate={startDate}
            endDate={endDate}
            onChange={setDateFilter}
            showPlaceholder={true}
          />
        </div>
      </div>

      <secondaryComponents.LoaderHelper
        isLoading={isLoadingJournalEntries}
        classNames="mt-5"
      >
        <secondaryComponents.JournalEntriesTable
          metaDetails={metaDetails}
          journalEntries={journalEntries}
          handleFetchJournalEntries={handleFetchJournalEntries}
          gotoPage={gotoPage}
        />
      </secondaryComponents.LoaderHelper>
    </>
  );
};
export default JournalEntriesTab;
